<template>
  <div
    class="absolute z-50 right-12 flex items-center gap-2 px-3 py-4 rounded-lg text-sm shadow-secondary"
    :class="classes"
  >
    <component :is="dynamicIcon" />
    <p v-html="text"></p>

    <CloseIcon
      class="ml-auto cursor-pointer active:opacity-80"
      @click="handleClick"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, type Component } from "vue";
import SuccessIcon from "../icons/SuccessIcon.vue";
import InfoIcon from "../icons/InfoIcon.vue";
import WarningIcon from "../icons/WarningIcon.vue";
import ErrorIcon from "../icons/ErrorIcon.vue";
import CloseIcon from "../icons/CloseIcon.vue";

interface PropsI {
  status: "success" | "info" | "warning" | "error";
  text: string;
  width?: number;
}

const props = defineProps<PropsI>();
const emit = defineEmits(["close"]);

const dynamicIcon = ref<null | Component>(null);

onMounted(() => {
  switch (props.status) {
    case "success":
      dynamicIcon.value = SuccessIcon;
      break;

    case "info":
      dynamicIcon.value = InfoIcon;
      break;

    case "warning":
      dynamicIcon.value = WarningIcon;
      break;

    case "error":
      dynamicIcon.value = ErrorIcon;
      break;
  }
});

const handleClick = () => {
  emit("close");
};

const classes = computed(() => `${props.status} ${props.width ? `w-[${props.width}px]` : 'w-1/3'}`);
</script>
